export const gmailTo = (to, subject = "", body = "") => {
  let url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}`;
  if (subject) url += `&su=${encodeURIComponent(subject)}`;
  if (body) url += `&body=${encodeURIComponent(body)}`;
  return url;
};

export const ENQUIRY_SUBJECT = "Project Enquiry — verivistaadvisory.com";

export const CAREERS_SUBJECT = "Careers — Resume | Your Name";
export const CAREERS_BODY = "Name:\nRole of interest:\nCity:\n\n(Please attach your resume)";
